import { render, staticRenderFns } from "./CropImage.vue?vue&type=template&id=13ec60cb&"
import script from "./CropImage.vue?vue&type=script&lang=js&"
export * from "./CropImage.vue?vue&type=script&lang=js&"
import style0 from "./CropImage.vue?vue&type=style&index=0&id=13ec60cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../backend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports